import { render, staticRenderFns } from "./PromoCodeReportModal.vue?vue&type=template&id=354c9c28&"
import script from "./PromoCodeReportModal.vue?vue&type=script&lang=ts&"
export * from "./PromoCodeReportModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports